import React from "react";

import { connect } from "react-redux";
import { loginAPI } from "../../services/login/actions";

import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { Link } from "react-router-dom";

import {
  setDeliveryDate,
  setHubId,
  setOrderId,
} from "../../services/order/actions";
import { formatPrice } from "../../utils/priceUtil";

function TableComponent(props) {
  // axios.defaults.headers.common["Authorization"] =
  //   "5ff3d38f-fdd1-448a-9370-0112d84c8b00";
  // axios.defaults.headers.common["Token"] =
  //   "4b3b596e-1b5b-4026-9051-eb752f818d98";

  var columnsMapping = props.header;
  var data = props.body;

  const setData = (rowData) => {
    switch (props.currentType) {
      case "HubOrders":
        props.setOrderId(rowData.id);
        break;
      case "HubOrdersSuppliers":
        props.setOrderId(rowData.supplier_id);
        props.setHubId(rowData.hub);
        props.setDeliveryDate(rowData.delivery_date);
        break;
      case "SuppliersOrders":
        props.setOrderId(rowData.order_number);
        break;
      case "Orders":
        props.setOrderId(rowData.order_id);
        break;
      default:
        break;
    }
  };

  const getColumnComponent = (column, rowData) => {
    switch (column.dataName) {
      case "rows":
      case "quantity":
      case "delivery_date":
      case "package":
      case "order_id":
      case "order_number":
      case "code":
        return (
          <Box
            textAlign="center"
            sx={{ marginBottom: "20px", marginTop: "5px" }}
          >
            {rowData[column.dataName]}
          </Box>
        );
      case "amount":
      case "salesprice":
        return (
          <Box
            textAlign="center"
            sx={{ marginBottom: "20px", marginTop: "5px" }}
          >
            {formatPrice(rowData[column.dataName])}
          </Box>
        );
      // return <Box textAlign="center">{rowData[column.dataName]}</Box>;

      case "arrow_button_order":
        return (
          <Link to="/order" style={{ textDecoration: "none" }}>
            <ArrowForwardIcon
              style={{ color: "var(--primary-color)" }}
              onClick={() => setData(rowData)}
            />
          </Link>
        );
      default:
        return (
          <Box
            textAlign="center"
            sx={{ marginBottom: "20px", marginTop: "5px" }}
          >
            {rowData[column.dataName]}
          </Box>
        );
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table className="table" aria-label="spanning table">
        <TableHead>
          <TableRow>
            {columnsMapping.map((column) => (
              <TableCell align="center">
                <span style={{ fontWeight: "bold" }}>{column.name}</span>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((rowData) => (
            <TableRow key={data.id}>
              {columnsMapping.map((column) => (
                <TableCell
                  align="left"
                  padding="none"
                  style={{ borderBottom: "none", marginBottom: "20px" }}
                >
                  {getColumnComponent(column, rowData)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

const mapStateToProps = (state) => ({
  currentType: state.general.currentType,
});

export default connect(mapStateToProps, {
  loginAPI,
  setOrderId,
  setHubId,
  setDeliveryDate,
})(TableComponent);
